import React from 'react';
import { Badge, Table } from 'reactstrap';
import ActionButton from '../../../../../Components/Common/ActionButton';
import { formatDateTime } from '../../formatters';
import UploadDocumentModal from './UploadDocumentModal';

const SOURCE_BADGE = {
  Planning: 'primary',
  Procurement: 'info',
  DMUT: 'warning',
};

const DocumentAttachmentTab = ({
  detail,
  uploadedDocs,
  viewOnly,
  uploadModalOpen,
  onOpenUpload,
  onCloseUpload,
  onSaveDoc,
  onDeleteDoc,
}) => {
  const seedDocs = (detail?.supportingDocuments ?? []).filter(
    d => d.showToDmut
  );
  const allDocs = [...seedDocs, ...uploadedDocs];

  const handleView = doc => {
    // Stub — preview not available in dummy mode
    alert(`Preview: ${doc.fileName}`);
  };

  return (
    <div className='p-3'>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <h6 className='text-uppercase text-muted fw-semibold mb-0 fs-11'>
          Document Attachment
        </h6>
        {!viewOnly && (
          <ActionButton
            variant='primary'
            size='sm'
            icon='ri-upload-2-line'
            onClick={onOpenUpload}
          >
            Upload Document
          </ActionButton>
        )}
      </div>

      <div className='table-responsive'>
        <Table bordered hover size='sm' className='align-middle mb-0'>
          <thead className='table-light'>
            <tr>
              <th>#</th>
              <th>File Name</th>
              <th>Document Title</th>
              <th>Source</th>
              <th>Last Updated</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {allDocs.length === 0 ? (
              <tr>
                <td colSpan={6} className='text-center text-muted py-4'>
                  Belum ada dokumen
                </td>
              </tr>
            ) : (
              allDocs.map((doc, idx) => (
                <tr key={doc.id ?? idx}>
                  <td className='text-muted'>{idx + 1}</td>
                  <td>{doc.fileName ?? '-'}</td>
                  <td className='fw-medium'>{doc.name ?? '-'}</td>
                  <td>
                    <Badge color={SOURCE_BADGE[doc.source] ?? 'secondary'}>
                      {doc.source ?? '-'}
                    </Badge>
                  </td>
                  <td>{formatDateTime(doc.lastUpdated)}</td>
                  <td>
                    <div className='d-flex gap-1'>
                      <ActionButton
                        variant='icon'
                        size='sm'
                        icon='ri-eye-line'
                        label='View'
                        onClick={() => handleView(doc)}
                      />
                      {doc.source === 'DMUT' && !viewOnly && (
                        <ActionButton
                          variant='icon'
                          size='sm'
                          danger
                          icon='ri-delete-bin-line'
                          label='Delete'
                          confirm={{
                            title: 'Delete this document?',
                            message: `"${doc.name ?? doc.fileName ?? 'This document'}" will be removed from the attachment list.`,
                          }}
                          onClick={() => onDeleteDoc(doc.id)}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      <UploadDocumentModal
        isOpen={uploadModalOpen}
        toggle={onCloseUpload}
        onSave={onSaveDoc}
      />
    </div>
  );
};

export default DocumentAttachmentTab;
